import { render, staticRenderFns } from "./MarkerPopupBody.vue?vue&type=template&id=b509c20e&"
import script from "./MarkerPopupBody.vue?vue&type=script&lang=js&"
export * from "./MarkerPopupBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports